export default __webpack_public_path__ + "static/media/paper.0da56b66.png";